<mat-form-field fxFlex="100" [floatLabel]="floatLabel">
  <input matInput type="text" (change)="valueChanged($event)"
         [(ngModel)]="inputValue" [disabled]="disabled"
         [textMask]="{mask: formatter.decimal.mask, pipe: formatter.decimal.pipe, guide: true, placeholderChar: formatter.placeholderChar}"/>
  <mat-placeholder i18n>{{placeholder}}</mat-placeholder>
  <span *ngIf="suffix" matSuffix i18n>{{suffix}}</span>
</mat-form-field>
